import { render, staticRenderFns } from "./DoctorRadioGroup.vue?vue&type=template&id=552f3736&scoped=true"
import script from "./DoctorRadioGroup.vue?vue&type=script&lang=js"
export * from "./DoctorRadioGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552f3736",
  null
  
)

export default component.exports